import { createQueryKey } from '../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../query/types';

const publishPermissionsKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys, 'publishPermissions'] as const,
    id: <U extends QueryKeyParam>(compositeId: U) =>
      createQueryKey({
        all: [...keys, 'publishPermissions', compositeId] as const,
        detail: [...keys, 'publishPermissions', compositeId, 'detail'] as const,
      }),
  });

export { publishPermissionsKeys };
